import { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { FaBars, FaTimes, FaFileInvoiceDollar } from 'react-icons/fa';
import logoImg from '../assets/images/logo.webp';


const HeaderContainer = styled.header`
  background-color: var(--white);
  box-shadow: var(--box-shadow-sm);
  position: sticky;
  top: 0;
  z-index: 1000;
  padding: 1rem 0;
`;

const Nav = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
`;

const Logo = styled(Link)`
  text-decoration: none;
  display: flex;
  align-items: center;
  
  &:hover {
    text-decoration: none;
  }
`;

const LogoImage = styled.img`
  height: 40px;
  width: auto;
`;

const MenuButton = styled.button`
  background: none;
  border: none;
  font-size: 1.5rem;
  color: var(--blue);
  cursor: pointer;
  display: none;
  
  @media (max-width: 768px) {
    display: block;
  }
`;

const MenuItems = styled.ul<{ isOpen: boolean }>`
  display: flex;
  list-style: none;
  margin: 0;
  gap: 1.5rem;
  align-items: center;
  
  @media (max-width: 768px) {
    position: fixed;
    top: 0;
    right: ${({ isOpen }) => (isOpen ? '0' : '-100%')};
    width: 250px;
    height: 100vh;
    background-color: var(--white);
    flex-direction: column;
    padding: 4rem 2rem;
    transition: right 0.3s ease-in-out;
    box-shadow: var(--box-shadow);
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  font-size: 1.5rem;
  color: var(--blue);
  cursor: pointer;
  display: none;
  
  @media (max-width: 768px) {
    display: block;
  }
`;

const MenuItem = styled.li`
  a {
    color: var(--gray-dark);
    text-decoration: none;
    font-weight: 500;
    transition: color 0.2s ease;
    
    &:hover, &.active {
      color: var(--blue);
    }
  }
`;

const ReservaButton = styled(Link)`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background-color: var(--blue);
  color: white !important;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  font-weight: 500;
  text-decoration: none;
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: var(--indigo);
    color: white !important;
  }
  
  svg {
    font-size: 1rem;
    color: white !important;
  }
`;

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  
  const closeMenu = () => {
    setIsMenuOpen(false);
  };
  
  return (
    <HeaderContainer>
      <Nav>
        <Logo to="/">
          <LogoImage src={logoImg} alt="Web a Bajo Coste" />
        </Logo>
        <MenuButton onClick={toggleMenu}>
          <FaBars />
        </MenuButton>
        <MenuItems isOpen={isMenuOpen}>
          <CloseButton onClick={closeMenu}>
            <FaTimes />
          </CloseButton>
          <MenuItem>
            <Link to="/" onClick={closeMenu}>Inicio</Link>
          </MenuItem>
          <MenuItem>
            <Link to="/servicios" onClick={closeMenu}>Servicios</Link>
          </MenuItem>
          <MenuItem>
            <Link to="/precios" onClick={closeMenu}>Precios</Link>
          </MenuItem>
          <MenuItem>
            <Link to="/proceso" onClick={closeMenu}>Proceso</Link>
          </MenuItem>
          <MenuItem>
            <Link to="/sobre-nosotros" onClick={closeMenu}>Sobre Nosotros</Link>
          </MenuItem>
          <MenuItem>
            <Link to="/contacto" onClick={closeMenu}>Contacto</Link>
          </MenuItem>
          <MenuItem>
            <ReservaButton to="/reserva" onClick={closeMenu}>
              <FaFileInvoiceDollar /> Presupuesto gratuito
            </ReservaButton>
          </MenuItem>
        </MenuItems>
      </Nav>
    </HeaderContainer>
  );
};

export default Header; 